// SummaryTableTickets.jsx
import React from 'react';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Props
 *   tickets: Array<{
 *     ticketID : number | string,
 *     date     : string,
 *     amount   : number | string,
 *     provider : string
 *   }>
 */
export default function SummaryTableTickets({ data }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 2,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ height: 'auto', minHeight: 'auto' }}>
          <Typography
            variant="h6"
            sx={{
              color: 'white',
              textAlign: 'center',
              mb: 2,
              fontWeight: 'bold',
            }}
          >
            {t('avslutteSkiftet.openTickets')}
          </Typography>
          <TableContainer
            component={Paper}
            sx={{
              overflowY: 'auto',
              bgcolor: '#1f2c67',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            <Table
              stickyHeader
              sx={{ color: 'white' }}
              aria-label="ticket table"
            >
              <TableHead sx={{ background: '#1f2c67' }}>
                <TableRow>
                  <TableCell align="center">
                    {t('avslutteSkiftet.date')}
                  </TableCell>
                  <TableCell align="center">
                    {t('avslutteSkiftet.provider')}
                  </TableCell>
                  <TableCell align="center">
                    {t('avslutteSkiftet.ticketID')}
                  </TableCell>
                  <TableCell align="center">
                    {t('avslutteSkiftet.amount')}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.map((row, idx) => (
                  <TableRow
                    key={idx}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '&:nth-of-type(odd)': { backgroundColor: '#232a45' },
                      '&:nth-of-type(even)': { backgroundColor: '#1a2036' },
                    }}
                  >
                    <TableCell align="center">{row.date}</TableCell>
                    <TableCell align="center">{row.provider}</TableCell>
                    <TableCell align="center">{row.ticketID}</TableCell>
                    <TableCell align="center">{row.amount}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
}
